
import { getAnalytics, logEvent, setUserId, setUserProperties as setFirebaseUserProperties } from 'firebase/analytics';
import { AnalyticsProvider } from './base';
import { app } from '@/lib/firebase';

/**
 * Firebase Analytics provider implementation
 */
export class FirebaseAnalyticsProvider implements AnalyticsProvider {
  private analytics: any = null;
  private initialized = false;

  async initialize(): Promise<void> {
    try {
      // Only initialize in browser environment
      if (typeof window !== 'undefined') {
        this.analytics = getAnalytics(app);
        this.initialized = true;
        console.log('Firebase Analytics initialized');
      }
    } catch (error) {
      console.error('Failed to initialize Firebase Analytics:', error);
    }
  }

  trackEvent(name: string, params?: Record<string, any>): void {
    if (!this.initialized) return;
    
    try {
      logEvent(this.analytics, name, params);
    } catch (error) {
      console.error(`Failed to track event "${name}":`, error);
    }
  }

  trackPageView(path: string, title?: string): void {
    if (!this.initialized) return;
    
    try {
      logEvent(this.analytics, 'page_view', {
        page_path: path,
        page_title: title || document.title,
      });
    } catch (error) {
      console.error(`Failed to track page view for "${path}":`, error);
    }
  }

  setUserProperties(properties: Record<string, any>): void {
    if (!this.initialized) return;
    
    try {
      setFirebaseUserProperties(this.analytics, properties);
    } catch (error) {
      console.error('Failed to set user properties:', error);
    }
  }

  identify(userId: string, properties?: Record<string, any>): void {
    if (!this.initialized) return;
    
    try {
      setUserId(this.analytics, userId);
      
      if (properties) {
        this.setUserProperties(properties);
      }
    } catch (error) {
      console.error(`Failed to identify user "${userId}":`, error);
    }
  }

  reset(): void {
    if (!this.initialized) return;
    
    try {
      // Firebase doesn't have a direct "reset" function
      // Setting user ID to null/empty string is a workaround
      setUserId(this.analytics, '');
    } catch (error) {
      console.error('Failed to reset analytics user:', error);
    }
  }
}
